export const validateGUID = (value: string): string | undefined => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

  if (!value.trim()) {
    return 'ID платежа обязателен для заполнения'
  }

  if (!uuidRegex.test(value)) {
    return 'Некорректный формат ID платежа'
  }

  return undefined
}
